var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.44015 5.32011L9.26212 1.54856C9.50537 1.30865 9.50537 0.919664 9.26212 0.679864C9.01908 0.440046 8.62491 0.440046 8.3819 0.679864L5.00004 4.0171L1.61831 0.679961C1.37518 0.440142 0.981044 0.440142 0.738012 0.679961C0.494881 0.91978 0.494881 1.30874 0.738012 1.54866L4.56003 5.3202C4.68161 5.44011 4.84078 5.5 5.00003 5.5C5.15935 5.5 5.31864 5.44 5.44015 5.32011Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownIconWhite);
export default __webpack_public_path__ + "static/media/dropdown_icon_white.7727c0b55d41f9eb6521cc455c21bd36.svg";
export { ForwardRef as ReactComponent };